import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {organizationsFeatureKey, OrganizationsState} from "./organizations.reducer";

export const getOrganizationsState = createFeatureSelector<OrganizationsState>(organizationsFeatureKey);

export const getOrganizations = createSelector(getOrganizationsState, (state) => state.data);
export const getOrganizationsLoading = createSelector(getOrganizationsState, SelectorUtil.isLoading);
